<template>
  <div class="tabs-item__wrapper"
       :class="{ contents: indexParent == 'handle' }"
  >

    <div class="tabs-item"
         v-for="(item, indexItem) in groupAndSort(filter)"
         :key="indexItem"
         :style="readStyleItem(indexItem)"
    >

      <div class="door-config__coverings"
           :class="{ handle: indexParent == 'handle' }"
           v-if="indexParent != 'countcover'"
      >

        <label v-for="(itemChildArr, indexItemChild) in arrParamsSelected(item)"
               :key="indexItemChild"
               class="door-config__cover"
               @click="changeCoverGlass(itemChildArr, indexItemChild, item.category)"
               @mousemove="hoverMechanism(indexItemChild)"
               @mouseleave="unHoverMechanism()"
        >

          <input type="radio" :name="indexParent" :checked="readCheckedCoverGlass(itemChildArr, indexItemChild)" />

          <div v-if="indexParent == 'mechanism'"
               class="img__preview"
               style="max-width: 175px"
          >
            <img :src="readPreview(itemChildArr, indexItemChild)" alt="preview" />
          </div>

          <i v-else
             :class="{ handle: indexParent == 'handle' }"
             :style="`display: flex; background-image: url('${readPreview(itemChildArr, indexItemChild)}');`"
          ></i>

          <span>{{ readDescription(itemChildArr, indexItemChild) }}</span>

        </label>

      </div>

      <div class="door-config__coverings"
           v-if="indexParent === 'countcover'"
      >

        <label class="door-config__cover"
               @click="changeCoverGlass(item, indexItem)"
        >

          <input type="radio" :name="indexParent" :checked="readCheckedCoverGlass(null, indexItem)" />

          <div class="img__preview">
            <img :src="item.preview" alt="preview" />
          </div>

          <span>{{ readDescription(item, indexItem) }}</span>

        </label>

      </div>

      <div class="js--door-config-polotno-text f-s-12 mt-0_5-rem handle"
           v-show="selectedParent?.handleColor"
      >
        {{ selectedParent?.handleColor }}
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "TheTabsItem",
  data() {
    return {
      selected: {},
      isHoverMechanism: false,
    };
  },
  methods: {
    readInfo(value) {
      console.log(value);
    },
    arrParamsSelected(item) {
      if (!this.selectedMechanism) {
        return item?.items ? item?.items : item
      } else {
        const arr = Object.assign({}, item);
        arr.items = arr?.items.filter((el) => {
          return el.mechanicsName && this.selectedMechanism.index && this.selectedMechanism.index.indexOf(el.mechanicsName) !== -1;
        });
        return arr.items;
      }
    },
    groupAndSort(data) {
      if (Array.isArray(data) && data.length > 0) {
        return data;
      } else if (typeof data == "object" && this.indexParent != "mechanism") {
        let Obj = {};
        Object.entries(data).forEach(([key, value]) => {
          if (+value.min <= this.width && this.width <= +value.max) {
            Obj[key] = value;
          }
        });
        return Obj;
      } else if (this.indexParent == "mechanism") {
        return data;
      }
    },
    readStyleItem(indexItem) {
      if (this.indexParent != "mechanism" && this.indexParent != "countcover") {
        if (this.indexParent == "handle") {
          return this.activeTabIndexParent[this.indexParent] == indexItem
            ? `display: contents;`
            : `display: none;`;
        }
        return this.activeTabIndexParent[this.indexParent] == indexItem
          ? `display: block;`
          : `display: none;`;
      }
      if (this.indexParent == "mechanism") {
        return this.selectedCountCover.countcover == indexItem
          ? "display: block"
          : "display: none";
      }
      if (this.indexParent == "countcover") {
        return "display: block";
      }
    },
    readCheckedCoverGlass(itemChildArr, indexItem) {
      if (this.indexParent != "mechanism" && this.indexParent != "countcover") {
        const selectedParent = this.selectedParent?.category ? { ...this.selectedParent, category: undefined } : this.selectedParent;
        const itemChild = itemChildArr?.category ? { ...itemChildArr, category: undefined } : itemChildArr;

        return JSON.stringify(selectedParent) == JSON.stringify(itemChild);
      }
      if (this.indexParent == "mechanism") {
        return this.selectedParent?.index == indexItem;
      }
      if (this.indexParent == "countcover") {
        return this.selectedParent?.countcover == indexItem;
      }
    },
    changeCoverGlass(itemData, index, category) {
      this.$emit("change", itemData, index, this.indexParent, category);
    },
    // Наведение мышкой на механизм,изменение переменной
    hoverMechanism(indexMechanism) {
      this.isHoverMechanism = indexMechanism;
    },
    // Уведение мышкой с механизма,изменение переменной
    unHoverMechanism() {
      this.isHoverMechanism = false;
    },
    readPreview(item, index) {
      if (this.indexParent == "mechanism" && this.isHoverMechanism == index) {
        return item.gif
      } else if (this.indexParent == "mechanism" && this.isHoverMechanism != index) {
        return item.preview;
      }
      else {
        return item?.preview || item?.handleColorPreview;
      }
    },
    readDescription(item, index) {
      if (this.indexParent == "mechanism") {
        return index;
      }
      if (item?.color || item?.handleColor) {
        return item?.color || item?.handleColor;
      }
      if (this.indexParent == "countcover") {
        let result = "";
        let n = Math.abs(index);
        n %= 100;
        if (n >= 5 && n <= 20) {
          result = "полотен";
        }
        n %= 10;
        if (n === 1) {
          result = "полотно";
        }
        if (n >= 2 && n <= 4) {
          result = "полотна";
        }
        return `${index} ${result}`;
      }
    },
  },
  props: {
    filter: [Object, Array],
    indexParent: [Number, String],
    activeTabIndexParent: [Object],
    selectedParent: [Object],
    selectedCountCover: [Object],
    width: [Number, String],
    selectedMechanism: [Object],
  }
};
</script>

<style>
.tabs-item__wrapper {
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
}

.tabs-item__wrapper.contents {
  display: contents;
}

.tabs-item__wrapper .door-config__cover input[type="radio"]+i.handle {
  border-radius: 50%;
  width: 24px;
  height: 24px;
}

.door-config__coverings.handle {
  /* grid-row: 1/2;
  grid-column: 1;
  margin-top: 35px;
  height: fit-content; */
}

.tabs-item__wrapper .door-config__cover input[type="radio"]+i.handle::before {
  background-color: transparent;
}

.js--door-config-polotno-text.handle {
  align-self: flex-end;
}

.img__preview {
  display: flex;
}

.countcover .tabs-item__wrapper {
  gap: 8px;
}
</style>